export default __webpack_public_path__ + "static/tools.url-a4846787e75fa3b584b0c51f89f76119.svg";